<mat-progress-bar mode="indeterminate" *ngIf="loaderService.loader$ | async"></mat-progress-bar>
<div *ngIf="!(loaderService.loader$ | async)" style="height: 4px"></div>
<div *ngIf="loader_debug" fxLayout="row wrap" fxLayoutAlign="left">
  <div *ngFor="let loader of loaderService.loaderList$ | async">- {{ loader }} -</div>
</div>
